module.exports = __webpack_public_path__ + "static/media/on_connect_fluids_Fr_pages.2090b2e4.pdf";